import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../../shared/ui/IconButton/IconButton';
import { InputFlat } from '../../../shared/ui/InputFlat/InputFlat';
import { TextButton } from '../../../shared/ui/TextButton/TextButton';
import icon4 from '../../../assets/pictures/icon4.png';
import { CheckboxWithLabel } from '../../../shared/ui/CheckboxWithLabel/CheckboxWithLabel';
import { Select } from '../../../shared/ui/Select/Select';
import { useState } from 'react';

type FormDialogProps = {
  open: boolean;
  onClose: () => void;
};
const PublishTemplate = ({ open, onClose }: FormDialogProps) => {
  const { t } = useTranslation();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [templateType, setTemplateType] = useState('template1');
  const [forPersons, setForPersons] = useState(false);
  const [personCanCreate, setPersonCanCreate] = useState(false);
  const [forTeams, setForTeams] = useState(false);
  const [forCompany, setForCompany] = useState(false);
  const [adminOnly, setAdminOnly] = useState(false);
  const [onlyOnce, setOnlyOnce] = useState(false);
  const [collaborationConfirmed, setCollaborationConfirmed] = useState(false);
  const [licenseConfirmed, setLicenseConfirmed] = useState(false);

  const handleSubmit = () => {
    const data = {
      title,
      description,
      templateType,
      forPersons,
      personCanCreate,
      forTeams,
      forCompany,
      adminOnly,
      onlyOnce,
      collaborationConfirmed,
      licenseConfirmed,
    };
    console.log('Submitting:', data);
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: 'md:w-3/4 lg:w-2/3 xl:w-3/5 min-w-[800px]',
      }}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      scroll="body"
      sx={{
        '& .MuiPaper-root': {
          backgroundImage: 'none',
          margin: 0,
          padding: 0,
          maxWidth: '600px !important',
        },
      }}
    >
      <IconButton
        classes="absolute right-1 top-1"
        icon={['fas', 'times']}
        onClick={onClose}
      />
      <DialogTitle
        sx={{
          padding: '1.5rem',
          paddingTop: '2rem',
        }}
        className="flex font-semibold items-center justify-between"
      >
        <div className="flex flex-col mb-4 gap-2">
          <Box
            className="font-semibold text-2xl"
            sx={{ color: 'primary.main' }}
          >
            Nutze diese Vorlage für deine Unternehmung
          </Box>
          <Box className="text-lg">
            Wenn du diese Vorlage veröffentlichst, kann sie von dir und den
            Anwender innen deiner Unternehmung eingesetzt werden.
          </Box>
        </div>
        <Box className="shrink-0 w-8"></Box>
      </DialogTitle>
      <Box className="p-6" sx={{ bgcolor: '#D5EBFC', minHeight: '120px' }}>
        <Box>
          <Box component="span" className="text-lg font-semibold">
            Vorschau deiner Vorlage
          </Box>
        </Box>
        <Box className="flex flex-row w-full rounded-lg pt-4">
          <Box className="w-fit mr-5 relative">
            <Box component="img" src="" className="h-[92px]" />
            <IconButton
              classes="absolute -top-2.5 -right-2.5 h-6 w-6 rounded-full text-xs"
              preset="primary"
              icon={['fas', 'pen']}
              iconColor="text-app"
              iconSize="inherit"
              onClick={() => {}}
            />
          </Box>

          <Box className="flex flex-col grow">
            <Box className="flex flex-row">
              <InputFlat
                preset="White"
                className="pr-2"
                widthClassName="w-full"
                placeholder="Wie soll deine Vorlage heißen?"
                value={title}
                onChange={setTitle}
              />
            </Box>
            <Box className="mt-2">
              <InputFlat
                preset="White"
                placeholder="Diese Vorlage kann genutzt werden für ... "
                value={description}
                onChange={setDescription}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className="flex flex-row p-6">
        <Box className="min-w-[280px] w-1/3">
          <Box className="font-semibold text-base">Mögliche Verwendung</Box>
          <Box>
            <CheckboxWithLabel
              label="Für Personen"
              checked={forPersons}
              onChange={setForPersons}
            />
            <CheckboxWithLabel
              label="Person darf selber anlegen"
              checked={personCanCreate}
              onChange={setPersonCanCreate}
              classes="ml-6"
              sx={{ color: 'text.primary' }}
            />
            <CheckboxWithLabel
              label="Innerhalb von Gruppen/Teams"
              checked={forTeams}
              onChange={setForTeams}
            />
            <CheckboxWithLabel
              label="Fur die gesamte Unternehmung"
              checked={forCompany}
              onChange={setForCompany}
            />
          </Box>
        </Box>

        <Box
          className="grow pl-4 pt-10 border-solid border-0 border-l"
          sx={{ borderLeft: '1px', borderColor: 'border.app' }}
        >
          <Select
            options={[
              { placeholder: 'template1', value: 'template1' },
              { placeholder: 'template2', value: 'template2' },
              { placeholder: 'template3', value: 'template3' },
            ]}
            value={templateType}
            onChange={(value) => setTemplateType(value)}
          />
          <Box className="flex flex-row items-center pt-4 gap-2">
            <CheckboxWithLabel
              label="darf nur Admin anlegen"
              checked={adminOnly}
              onChange={setAdminOnly}
            />
            <CheckboxWithLabel
              label="darf nur 1x angelegt werden"
              checked={onlyOnce}
              onChange={setOnlyOnce}
            />
          </Box>
        </Box>
      </Box>
      <Box className="p-6" sx={{ bgcolor: '#EFEFEF' }}>
        <Box className="font-semibold text-base">
          Ist ein Kollaborations-Tool-Gut organisieren und effektiv zusammen
          arbeiten!
        </Box>
        <CheckboxWithLabel
          label="Du berechtigst mit dieser Einstellung folgende Personen"
          checked={collaborationConfirmed}
          onChange={setCollaborationConfirmed}
        />
        <Box sx={{ color: 'text.secondary' }}>...</Box>
      </Box>

      <Box className="p-6">
        <Box className="font-semibold text-base">
          Ich veröffentliche diese Vorlage für: (Name der Unternehmung bzw.
          Dropdown).
        </Box>
        <CheckboxWithLabel
          label="Hiermit bestatige ich, dass ich folgende Been fur das Tellen von Toolvorlagen unter der Verwendung von Open Source MIT-Lizenz gelesen habe"
          checked={licenseConfirmed}
          onChange={setLicenseConfirmed}
        />
      </Box>
      <DialogContent className="border-b-0" sx={{ padding: '1.5rem' }}>
        <Box className="flex justify-end mt-4">
          <TextButton
            classes="mr-2"
            preset="underline"
            textTransform="none"
            onClick={onClose}
          >
            {t('app.cancel')}
          </TextButton>
          <TextButton
            preset="primary"
            onClick={handleSubmit}
            disabled={!licenseConfirmed}
          >
            Speichern und veröffentlichen
          </TextButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PublishTemplate;
